import { createWatchStore, updateWatchStore, useWatch } from 'src/js/store/watch';

const Events: any = {};
createWatchStore(Events, { allowWatchingFutureProperties: true });
export default Events;

export const triggerEvent = (name: string, data?: string | boolean) => {
  const newObj: any = {};
  newObj[name] = data || true;
  updateWatchStore(Events, newObj);
  delete Events[name];
};

export const watchEvent = (name: string, callback: () => void) => {
  useWatch(Events, name, callback);
};
